import { render } from "./OrderUserInfos.vue?vue&type=template&id=70f8d338"
import script from "./OrderUserInfos.vue?vue&type=script&lang=js"
export * from "./OrderUserInfos.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__